import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Module
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
// Main
import { RulesComponent } from './rules.component';
// Components
import { RuleComponent } from './components/rule/rule.component';
import { RuleSetComponent } from './components/rule-set/rule-set.component';
import { RuleNotificationsComponent } from './components/rule-notifications/rule-notifications.component';
import { RuleCreateComponent } from './components/rule-create/rule-create.component';
import { RuleCommentCreateComponent } from './components/rule-comment/rule-comment-create.component';
import { RuleStipCreateComponent } from './components/rule-stip/rule-stip-create.component';
import { RuleStipOptionComponent } from './components/rule-stip/components/rule-stip-option.component';
import { RuleCommentStipViewItemComponent } from './components/rule-comment-stip/rule-comment-stip-view-item.component';
import { RuleCommentStipViewComponent } from './components/rule-comment-stip/rule-comment-stip-view.component';
// Pipes
import { CommentsModeButtonTextPipe } from './pipes/comments-mode-btn-text.pipe';
import { RuleSectionLabel } from './pipes/rule-section-label.pipe';
import { OrderRuleBy } from './pipes/order-rule-by.pipe';
// Services
import { RulesService } from './services/rules.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		CvComponentLibraryModule
	],
	declarations: [
		// Main
		RulesComponent,
		// Components
		RuleComponent,
		RuleSetComponent,
		RuleNotificationsComponent,
		RuleCreateComponent,
		RuleCommentCreateComponent,
		// Stips
		RuleStipCreateComponent,
		RuleStipOptionComponent,
		RuleCommentStipViewItemComponent,
		RuleCommentStipViewComponent,
		// Pipe
		CommentsModeButtonTextPipe,
		RuleSectionLabel,
		OrderRuleBy,
	],
	exports: [
		RulesComponent,
		RuleSetComponent
	],
	providers: [
		RulesService
	]
})
export class RulesModule { }
